import * as L from 'leaflet';
import {Attribute} from './attribute';

export class MarkerDataExtended extends L.Marker {
  attributes: Attribute<string>[];

  constructor(latLng: L.LatLngExpression, data: Attribute<string>[], options?: L.MarkerOptions) {
    super(latLng, options);
    this.setData(data);
  }

  getData() {
    return this.attributes;
  }

  setData(data: any) {
    this.attributes = data;
  }

  id(): string {
   return this.value('id');
  }

  value(key: string): string {
    return this.attributes?.find(a => a.key === key)?.value;
  }
}
